// Byte and text helpers shared by every part of the protocol (docs/protocol.md, "Encoding").
const enc = new TextEncoder();
const dec = new TextDecoder();
export const utf8 = (s) => enc.encode(s);
export const fromUtf8 = (b) => dec.decode(b);
export function b64u(bytes) {
    const b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
    let s = "";
    for (let i = 0; i < b.length; i++)
        s += String.fromCharCode(b[i]);
    return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function fromB64u(s) {
    if (!/^[A-Za-z0-9_-]*$/.test(s))
        throw new ProtocolError("bad_encoding", "not base64url");
    const pad = "=".repeat((4 - (s.length % 4)) % 4);
    const bin = atob(s.replace(/-/g, "+").replace(/_/g, "/") + pad);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++)
        out[i] = bin.charCodeAt(i);
    return out;
}
export function concat(...parts) {
    const out = new Uint8Array(parts.reduce((n, p) => n + p.length, 0));
    let o = 0;
    for (const p of parts) {
        out.set(p, o);
        o += p.length;
    }
    return out;
}
export function randomBytes(n) {
    const b = new Uint8Array(n);
    crypto.getRandomValues(b);
    return b;
}
/** A fresh random identifier: 16 bytes, base64url (22 characters). */
export const randomId = () => b64u(randomBytes(16));
/** WebCrypto wants ArrayBuffer-backed views; this keeps TypeScript and every runtime happy. */
export const buf = (b) => new Uint8Array(b);
export class ProtocolError extends Error {
    code;
    constructor(code, message) {
        super(`${code}: ${message}`);
        this.code = code;
        this.name = "ProtocolError";
    }
}
//# sourceMappingURL=encoding.js.map